import es from './es.json'

const general = {
  select_option: 'Seleccione una opción',
  value: 'Valor',
  name: 'Nombre',
  placeholder: 'Indicación',
  title: 'Título',
  title_group: 'Título del grupo',
  subtitle: 'Subtítulo',
  text: 'Texto',
  list: 'Lista',
  boolean: 'Booleano',
  type: 'Tipo',
  action: 'Acción',
  property: 'Propiedad',
  logic: 'Lógico',
  permanent: 'Permanente',
  size: 'Tamaño',
  avaible_sizes: 'Tamaños admitidos',
  variant: 'Variante',
  right: 'Derecha',
  left: 'Izquierda',
  option: 'Opción',
  options: 'Opciones',
  validations: 'Validaciones',
  equal: 'igual',
  different: 'diferente',
  higher: 'mayor',
  greater_than_or_equal: 'mayor o igual',
  less: 'menor',
  less_than_or_equal: 'menor o igual',
  settings: 'Configuración',
  none: 'Ninguno',
  every: 'Todos',
  today: 'Hoy',
  email: 'Email',
  date: 'Fecha',
  peview: 'Visualización',
  default_option: 'Opción por defecto',
  default_value: 'Valor por defecto',
  all_options_by_default: 'Todas las opciones pre-cargadas por defecto',
  small: 'Pequeño',
  medium: 'Mediano',
  large: 'Grande',
  multiple: 'Múltiple',
  data_origin: 'Origen de datos',
  users: 'Usuarios',
  description: 'Descripción',
  variable: 'Variable',
  variables: 'Variables',
  actions: 'Acciones',
  // Permissions
  action_deny_by_insufficient_permissions: 'Lo sentimos, no tiene permisos para guardar los cambios.',
  // Document types
  generic: 'Genérico',
  specific: 'Específco',
  comunicable: 'Comunicable',
  incomunicable: 'No Comunicable',
  public: 'Público',
  private: 'Privado',
  electronic: 'Electrónica',
  digital: 'Digital',
  prefix: 'Prefjo',
  id: 'ID',
  reject: 'Rechazar',
  view_more: 'Ver Más'
}

const accion = {
  save: 'Guardar',
  edit: 'Editar',
  save_or_update: 'Guardar o Actualizar',
  save_as_template: 'Guardar como Template',
  success_saved: 'Se guardó exitosamente',
  update: 'Guardar',
  delete: 'Eliminar',
  defuse: 'Desactivar',
  activate: 'Activar',
  cancel: 'Cancelar',
  publish: 'Publicar',
  add: 'Agregar',
  add_param: 'Agregar parámetro',
  add_option: 'Agregar opción',
  add_field: 'Agregar campo',
  selected: 'Seleccionado',
  disabled: 'Deshabilitado',
  required: 'Requerido',
  select_an_option: 'Seleccione una opción',
  depends_of: 'Depende de',
  create: 'Crear',
  update_literal: 'Actualizar',
  show_preview: 'Mostrar Previsualización',
  show_variables: 'Mostrar variables',
  copy_to_clipboard: 'Copiar al porta papeles'
}

const formbuilderView = {
  form_builder: 'Generador de formularios',
  general_settings: 'Configuración general',
  form_title: 'Título del formulario',
  form_alias: 'Alias',
  endpoint_to_manage_all_requests: 'Endpoint para solicitudes GET, POST, PUT y DELETE',
  endpoint_to_manage_all_requests_help: 'A menos que se especifique lo contrario, este endpoint maneja todos los request al servidor',
  path_to_redirect: 'Ruta para redirección',
  success_action_message_setter: 'Mensaje de acción exitosa',
  is_internal_form: 'Es un formulario interno',
  edit_mode: 'Edición',
  preview_mode: 'Previsualización',
  form_fields: 'Campos del formulario',
  form_must_have_at_least_one_field: 'El formulario debe tener al menos un elemento.',
  add_field_to_form: 'Agregar un campo al formulario',
  watch_saved_form_here: 'Puedes ver el formulario aquí',
  view_modes: 'Modos de visualizar'
}

const formbuilderComponents = {
  post_path: 'POST Path',
  put_path: 'PUT Path',
  delete_type: 'Tipo de borrado',
  delete_path: 'DELETE Path',
  comp_columns: 'Columnas',
  comp_icon: 'Icono',
  comp_icon_position: 'Posición del icono',
  comp_styles: 'Estilos',
  require_confirmation: 'Requiere confirmación',
  confirmation_title_setter: 'Título de la confirmación',
  confirmation_message_setter: 'Mensaje de la confirmación',
  prop_to_manage_logic_delete: 'Propiedad que se edita para el borrado lógico',
  custom_params: 'Parámetros personalizados',
  comp_title_help: 'Título que se mostrará sobre el campo',
  checkbox_label_help: 'Nombre usado para la visibilidad basada en una condición',
  comp_name_help: 'Nombre interno para guardar el valor del campo en el sistema',
  comp_placeholder_help: 'Texto indicativo que aparecerá en el campo cuando se comience a completar el formulario',
  comp_size_help: 'Tamaño del componente',
  comp_variant_help: 'Seleccione una variante para el componente',
  comp_type_help: 'Seleccione un tipo de componente',
  checkbox_simple_label: 'Texto para Checkbox simple',
  checkbox_uncheck_value: 'Valor Sin Chequear',
  checkbox_label_position: 'Posición del título',
  comp_invalid_text_setter: 'Texto de campo inválido',
  comp_valid_text_setter: 'Texto de campo válido',
  color_picker_label: 'Color por defecto',
  desktop_view_width: 'Ancho vista escritorio',
  value_has_to_be_equal_to: 'El valor tiene que ser igual a',
  visible_only_on_edit_mode: 'Visible solo en modo edición',
  disabled_only_on_edit_mode: 'Deshabilitado solo en modo edición',
  helper_text_setter: 'Texto de ayuda',
  helper_text_setter_help: 'Ayuda para el usuario sobre el campo a completar (igual a este mensaje)',
  comp_min_date: 'Fecha mínima',
  comp_format_date: 'Formato de fecha',
  subtitle_placeholder_example: 'Un Subtítulo de ejemplo',
  comp_post_endpoint_setter: 'Endpoint para el POST',
  comp_post_endpoint_help: 'Endpoint para los request al servidor al cargar un archivo',
  comp_initial_latitude: 'Latitud Inicial',
  comp_initial_length: 'Longitud Inicial',
  map_height: 'Altura',
  comp_is_vertical: 'En vertical',
  comp_radios: 'Radios',
  comp_buttons: 'Botones',
  comp_numeration: 'Numeración',
  button_text: 'Texto del botón',
  min_length: 'Longitud mínima',
  max_length: 'Longitud máxima',
  max_files_allow: 'Cantidad máxima de archivos',
  max_files_allow_help: 'Indicar 0 deshabilita el componente',
  file_types_allow: 'Tipos de archivos permitidos',
  file_max_size_allow: 'Tamaño máximo (en MB)',
  only_unique_files: 'Solo archivos únicos',
  set_my_privileges: 'Setear mis privilegios',
  set_all_privileges: 'Setear todos los privilegios',
  signers_options_origin_setter_help: 'Usuarios que se mostrarán como opciones para firmar',
  width_digital_signature: 'Con firma digital',
  select_elemet_type: 'Seleccione el tipo de elemento',
  preview_path: 'Path para la previsualización',
  preview_button: 'Botón de previsualización',
  customize_this_title: 'Personaliza este título presionando "Editar Dashboard"',
  // Nombres de componentes
  LmCodeInput: 'Campo de código',
  LmTreeSelect: 'Selector en árbol',
  cannot_be_undone: 'Esta acción no puede deshacerse'
}

const documenttypesView = {
  document_types_generator: 'Generador de Tipos de documento',
  document_type_name: 'Nombre del Tipo de Documento',
  document_type_name_placeholder: 'Ingrese el nombre del Tipo de Documento',
  document_type_alias: 'Alias del Tipo de Documento',
  document_type_alias_placeholder: 'Ingrese el alias del Tipo de Documento',
  document_type_description: 'Descripción del Documento',
  document_type_description_placeholder: 'Esta descripción se mostrará como ayuda durante el alta del documento',
  numerator_type: 'Tipo de Numerador',
  comunicable_type: 'Tipo de Comunicación',
  visibility_type: 'Tipo de Visibilidad',
  signature_type: 'Tipo de Firma',
  numerator_prefix: 'Prefjo para numeración',
  numerator_prefix_help: 'Grupo de letras que se antepondrán al número del documento para identificarlo',
  numerator_type_help: 'Esta opción permite definir si los documentos de este tipo serán numerados con un numerador específico (por ejemplo, los Decretos) o si se utilizará un numerador genérico',
  comunicable_type_help: 'Si un documento es comunicable, el usuario tendrá la posibilidad de seleccionar destinatarios a los que se informará cuando el documento esté finalizado',
  visibility_type_help: 'Los documentos Privados solo pueden ser vistos por su creador, por el destinatario del documento si existe y por cualquier otra persona o área que el creador seleccione. Si se seleccion esta opción, al crear un documento, el usuario podrá indicar los usuarios o áreas habilitados a visualizarlo',
  signature_type_help: 'Esta opción permite indicar si el documento deberá ser firmado de manera Digital o Electrónica. De indicarse Firma Digital solo habilitarán para firmar los usuarios que tengan asociado este tipo de firma en su perfil',
  import_form_components_from_another_document_type: 'Cargar campos desde otro tipo de documento',
  publish_confirmation_title: '¿Estás seguro de publicar este Tipo de Documento?',
  publish_confirmation_message: 'Publicar el Tipo de Documento lo hará visible para poder crear Documentos dentro. No podrás editar sus caracteristicas una vez publicado.',
  defuse_confirmation_title: '¿Estás seguro de despublicar este Tipo de Documento?',
  defuse_confirmation_message: 'Si despublicas este Tipo de Documento no podrás crear nuevos documentos en el futuro. Si podrás ver los documentos creados.',
  update_template: 'Actualizar template',
  create_template_name: 'Crea un nombre para el template',
  template_reference_name: 'Nombre de referencia para el template',
  save_and_publish: 'Guardar y Publicar'
}

const documentsView = {
  send_to_sign: 'Enviar a Firmar',
  select_a_content_template: 'Seleccione un template de contenido'
}

const listbuilderView = {
  data_origin: 'Origen de datos',
  help_data_origin: 'Origen de datos del listado',
  placeholder_origen_de_datos: 'Seleccione una opción',
  help_alias: 'Alias para identificar el formulario en el listado',
  label_titulo_listado: 'Título del listado',
  help_titulo_listado: 'Título del listado',
  titulo_ventana_busqueda_inicial: 'Búsqueda inicial',
  label_busqueda_inicial: 'Búsqueda inicial',
  help_busqueda_inicial: 'Prefiltrado con búsqueda',
  help_busqueda_meta: 'Filtrado en base a los datos de sesión del usuario',
  label_busqueda_meta: 'Meta búsqueda',
  label_ordenar_por: 'Ordenar por',
  help_ordenar_por: 'Orden inicial',
  btn_agregar_busqueda: 'Aplicar búsqueda',
  btn_aplicar_columnas: 'Aplicar columnas',
  titulo_ventana_botones: 'Botones',
  label_valor: 'Valor',
  placeholder_valor: 'Nuevo formulario',
  label_to: 'Ruta',
  placeholder_to: '/listbuilderui/',
  label_endpointToValidateVisibility: 'Ruta que valida visibilidad',
  placeholder_endpointToValidateVisibility: '/endpoint/',
  label_mostrar: 'Visible',
  label_checkbox_deshabilitar: 'Deshabilitado',
  label_color: 'Color de fondo',
  btn_agregar_boton: 'Agregar botón',
  titulo_ventana_paginado: 'Paginado',
  label_pagina: 'Página',
  help_pagina: 'Número de página que iniciará el listado',
  label_perpage: 'Cantidad por página',
  help_perpage: 'Cantidad de items a listar',
  btn_aplicar_paginado: 'Aplicar paginado',
  titulo_ventana_acciones: 'Acciones',
  label_types: 'Tipos:',
  placeholder_modal_endpoint: '/endpoint/',
  label_modal_endpoint: 'Ruta',
  label_modal_requestMethod: 'Método de petición',
  disabled_option: 'Seleccione una opción',
  label_modal_delayAfterSubmit: 'Retraso tras el envío',
  placeholder_modal_delayAfterSubmit: 'Delay',
  placeholder_modal_title: 'Título modal',
  label_modal_title: 'Título',
  label_modal_tooltip: 'Descripción emergente',
  placeholder_modal_tooltip: 'Descripción',
  label_modal_message: 'Mensaje',
  placeholder_modal_message: 'Mensaje',
  label_isComment: 'Comentario ( textarea )',
  label_modal_labelComment: 'Título',
  placeholder_modal_labelComment: 'Título textarea',
  label_modal_required: 'Requerido',
  label_modal_fontAwesomeIcon: 'Ícono (fontawesome)',
  label_modal_fontAwesomeIcon_small: 'Todos los íconos: ',
  name_path: 'Ruta',
  name_modal: 'Modal',
  label_action_tooltip: 'Descripción emergente',
  placeholder_action_tooltip: 'Descripción',
  label_action_to: 'Ruta',
  placeholder_action_to: '/listbuilder/edit/:_id',
  btn_agregar_action: 'Agregar acción',
  titulo_ventana_modo: 'Modo',
  label_modo_listado: 'Listado',
  label_modo_mapa: 'Mapa',
  titulo_ventana_preview: 'Vista previa',
  titulo_sin_privilegios: 'Lo sentimos, no tiene permisos para guardar los cambios.',
  ver_el_ultimo_cargado: '👉 Ver el último listado cargado',
  listado_de_listados: 'Listado de Listados',
  label_modo_caja: 'Caja',
  btn_agragar_modo: 'Aplicar modo',
  label_cantidad_filas: 'Cantidad de filas',
  label_titulo: 'Título',
  label_categoria: 'Categoría',
  label_contenido: 'Contenido',
  placeholder_columna: 'Columna',
  label_borde_superior: 'Borde superior',
  label_color_borde_superior: 'Color borde superior',
  titulo_ventana_aggregations: 'Filtros',
  btn_agregar_aggregations: 'Agregar filtro',
  placeholder_título_filtro: 'Título del filtro',
  titulo_acciones: 'Acciones',
  titulo_modals: 'Modals',
  titulo_columnas: 'Columnas',
  label_columnas: 'Seleccione las columnas que se mostrarán en el listado.'

}

const esLocales = Object.assign({},
  es,
  general,
  accion,
  formbuilderView,
  listbuilderView,
  formbuilderComponents,
  documenttypesView,
  documentsView
)

export default esLocales
